/**
 * @generated SignedSource<<5c117934353e564df69496bd54a70b58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteReportByIdInput = {
  clientMutationId?: string | null;
  id: string;
};
export type useReportDeleteMutation$variables = {
  input: DeleteReportByIdInput;
};
export type useReportDeleteMutation$data = {
  readonly deleteReportById: {
    readonly deletedReportId: string | null;
  } | null;
};
export type useReportDeleteMutation = {
  variables: useReportDeleteMutation$variables;
  response: useReportDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedReportId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteReportPayload",
        "kind": "LinkedField",
        "name": "deleteReportById",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteReportPayload",
        "kind": "LinkedField",
        "name": "deleteReportById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedReportId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c07f45b0f955d73cd27963c0547184a9",
    "id": null,
    "metadata": {},
    "name": "useReportDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useReportDeleteMutation(\n  $input: DeleteReportByIdInput!\n) {\n  deleteReportById(input: $input) {\n    deletedReportId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c7b7b0bb6c47b7f8fca9eee085a58ac";

export default node;
